<template>
  <div class="inquiry-page">
    <banner></banner>
    <!-- menu -->
    <ul class="tabs w-1200">
      <router-link
        class="tab-item"
        :class="{ active: item.route === activeRoute }"
        :to="{ name: item.route }"
        v-for="item in menus"
        :key="item.route"
      >
        {{ item.label }}
      </router-link>
    </ul>
    <div class="assets-wrapper w-1200">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Banner from "@/components/Banner";

export default {
  components: {
    banner: Banner
  },
  data() {
    return {
      menus: [
        {
          label: "在线询价",
          route: "inquirySearch"
        },
        {
          label: "历史记录",
          route: "inquiryList"
        },
        {
          label: "操作提示",
          route: "inquiryGuide"
        }
      ]
    };
  },
  computed: {
    activeRoute() {
      return this.$route.name;
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/pages/inquiry.scss";
</style>
